import { createAction } from '@reduxjs/toolkit';
import { produce } from 'immer';
import { applyPatch, createPatch } from 'rfc6902';

function _define_property$2(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$2(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$1(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$1(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$1(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var popupTargetOrigin = createAction("pop-up/target-origin");
var popupReducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        popUp: {
            isReady: false,
            targetOrigin: window.origin
        }
    }, action = arguments.length > 1 ? arguments[1] : void 0;
    if (action.type === "init-sync") {
        return _object_spread$2({
            popUp: _object_spread_props$1(_object_spread$2({}, state.popUp), {
                isReady: true
            })
        }, action["payload"]);
    } else if (action.type === "state-sync") {
        return produce(state, function(draft) {
            applyPatch(draft, action["payload"]);
        });
    } else if (popupTargetOrigin.match(action)) {
        return _object_spread_props$1(_object_spread$2({}, state), {
            popUp: _object_spread_props$1(_object_spread$2({}, state.popUp), {
                targetOrigin: action.payload
            })
        });
    }
    return state;
};
var popupMiddleware = function() {
    var params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return function(param) {
        var dispatch = param.dispatch;
        var targetOrigin = params.targetOrigin || window.origin;
        setTimeout(function() {
            return dispatch(popupTargetOrigin(targetOrigin));
        }, 0);
        window.addEventListener("message", function(e) {
            if (e.source !== window.opener || e.origin !== targetOrigin) {
                return;
            }
            if (e.data.type === "init-sync" || e.data.type === "state-sync") {
                dispatch(e.data);
            }
        });
        var postMessage = function(message) {
            window.opener.postMessage(message, {
                targetOrigin: targetOrigin
            });
        };
        postMessage({
            type: "init"
        });
        return function(next) {
            return function(action) {
                if ([
                    "init-sync",
                    "state-sync",
                    popupTargetOrigin.type
                ].includes(action.type)) {
                    return next(action);
                }
                if (action.type.startsWith("topUp/cardPayment/") || action.type.startsWith("topUp/paymentRequest/")) {
                    postMessage({
                        type: "store-action",
                        payload: _object_spread_props$1(_object_spread$2({}, action), {
                            meta: _object_spread_props$1(_object_spread$2({}, action.meta), {
                                arg: _object_spread_props$1(_object_spread$2({}, action.meta.arg), {
                                    stripe: undefined,
                                    elements: undefined,
                                    event: action.meta.arg.event ? _object_spread_props$1(_object_spread$2({}, action.meta.arg.event), {
                                        complete: undefined
                                    }) : undefined
                                })
                            })
                        })
                    });
                } else {
                    postMessage({
                        type: "store-action",
                        payload: action
                    });
                }
            };
        };
    };
};

function _define_property$1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$1(target, key, source[key]);
        });
    }
    return target;
}
var updatePopUpParentState = createAction("updatePopUpParentState");
var popUpParentReducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        targetOrigin: window.origin
    }, action = arguments.length > 1 ? arguments[1] : void 0;
    if (updatePopUpParentState.match(action)) {
        return _object_spread$1({}, state, action.payload);
    }
    return state;
};
var popupParentMiddleware = function(slices) {
    return function(param) {
        var getState = param.getState, dispatch = param.dispatch;
        var popUpWindow;
        var isPopupInitialized = false;
        var postMessage = function(message) {
            return popUpWindow === null || popUpWindow === void 0 ? void 0 : popUpWindow.postMessage(message, {
                targetOrigin: getState().popUpParent.targetOrigin
            });
        };
        var getObservedState = function() {
            var state = getState();
            return Object.fromEntries(slices.map(function(slice) {
                return [
                    slice,
                    state[slice]
                ];
            }));
        };
        var isCurrentWindowPopupSource = function(popUpWindow) {
            var _popUpWindow_opener;
            return ((_popUpWindow_opener = popUpWindow.opener) === null || _popUpWindow_opener === void 0 ? void 0 : _popUpWindow_opener.location) === window.location;
        };
        window.addEventListener("message", function(e) {
            var targetOrigin = getState().popUpParent.targetOrigin;
            if (e.source !== popUpWindow || e.origin !== targetOrigin) {
                return;
            }
            if (e.data.type === "init") {
                postMessage({
                    type: "init-sync",
                    payload: getObservedState()
                });
                isPopupInitialized = true;
            } else if (e.data.type === "store-action") {
                dispatch(e.data.payload);
            }
        });
        return function(next) {
            return function(action) {
                if (!action.type.startsWith("pop-up") && popUpWindow && isPopupInitialized) {
                    var prevState = getObservedState();
                    var result = next(action);
                    var newState = getObservedState();
                    var patch = createPatch(prevState, newState);
                    if (patch.length) {
                        postMessage({
                            type: "state-sync",
                            payload: patch
                        });
                    }
                    return result;
                }
                if (action.type === "pop-up/focus") {
                    if (popUpWindow) {
                        if (isCurrentWindowPopupSource(popUpWindow)) {
                            popUpWindow.focus();
                        } else {
                            popUpWindow.close();
                            dispatch(openPopUp());
                        }
                    }
                }
                if (openPopUp.match(action)) {
                    if (popUpWindow && !popUpWindow.closed) {
                        return dispatch(popupAlreadyOpened());
                    }
                    var _action_payload = action.payload, origin = _action_payload.origin, path = _action_payload.path, app = _action_payload.app;
                    dispatch(updatePopUpParentState({
                        targetOrigin: origin
                    }));
                    var _window_screen_availLeft, _ref, _window_screen_availTop, _ref1;
                    var screen = {
                        height: window.screen.availHeight,
                        width: window.screen.availWidth,
                        left: (_ref = (_window_screen_availLeft = window.screen.availLeft) !== null && _window_screen_availLeft !== void 0 ? _window_screen_availLeft : window.screen.left) !== null && _ref !== void 0 ? _ref : 0,
                        top: (_ref1 = (_window_screen_availTop = window.screen.availTop) !== null && _window_screen_availTop !== void 0 ? _window_screen_availTop : window.screen.top) !== null && _ref1 !== void 0 ? _ref1 : 0
                    };
                    var w = 400;
                    var h = 678;
                    var x = screen.width / 2 + screen.left - w / 2;
                    var y = screen.height / 2 + screen.top - h / 2;
                    if (!popUpWindow || popUpWindow.closed) {
                        var params = new URLSearchParams();
                        if (app) {
                            params.append("app", app);
                        }
                        popUpWindow = window.open("".concat(origin).concat(path).concat(params.size ? "?".concat(params.toString()) : ""), "Recast", "toolbar=no, 'titlebar=0', location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=".concat(w, ", height=").concat(h, ", top=").concat(y, ", left=").concat(x));
                        var closeInterval = setInterval(function() {
                            if (popUpWindow === null || popUpWindow === void 0 ? void 0 : popUpWindow.closed) {
                                clearInterval(closeInterval);
                                dispatch({
                                    type: "pop-up/close"
                                });
                                popUpWindow = null;
                                isPopupInitialized = false;
                            }
                        }, 1000);
                    }
                }
                return next(action);
            };
        };
    };
};
var openPopUp = createAction("pop-up/open", function(payload) {
    return {
        payload: _object_spread$1({
            origin: window.origin,
            path: "/pop-up"
        }, payload)
    };
});
var focusPopUp = function() {
    return {
        type: "pop-up/focus"
    };
};
var popupAlreadyOpened = function() {
    return {
        type: "pop-up/already-opened"
    };
};
var popUpCloseMatcher = function(action) {
    return action.type === "pop-up/close";
};

function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var popupModuleName = Symbol();
var id = 0;
var getRequestId = function() {
    return ++id;
};
function initiateInPopUp(dispatch, api, data, queries, actionType, source, targetOrigin) {
    return _initiateInPopUp.apply(this, arguments);
}
function _initiateInPopUp() {
    _initiateInPopUp = _async_to_generator(function(dispatch, api, data, queries, actionType, source, targetOrigin) {
        var _api_endpoints_data_endpointName, query, result;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    query = dispatch((_api_endpoints_data_endpointName = api.endpoints[data.endpointName]).initiate.apply(_api_endpoints_data_endpointName, _to_consumable_array(data.args)));
                    queries.set(query.requestId, query);
                    return [
                        4,
                        query
                    ];
                case 1:
                    result = _state.sent();
                    source === null || source === void 0 ? void 0 : source.postMessage({
                        type: actionType,
                        action: "initiate/response",
                        requestId: data.requestId,
                        result: result,
                        queryCacheKey: "queryCacheKey" in query ? query.queryCacheKey : undefined
                    }, {
                        targetOrigin: targetOrigin
                    });
                    return [
                        2
                    ];
            }
        });
    });
    return _initiateInPopUp.apply(this, arguments);
}
function unsubscribeInPopUp(queries, data) {
    var _queries_get;
    (_queries_get = queries.get(data.requestId)) === null || _queries_get === void 0 ? void 0 : _queries_get.unsubscribe();
    queries.delete(data.requestId);
}
function resetInPopUp(queries, data) {
    var mutation = queries.get(data.requestId);
    if (mutation && "reset" in mutation) {
        mutation.reset();
    }
    queries.delete(data.requestId);
}
var rtkPopupMiddleware = function(api, originalMiddleware, actionType) {
    return function(param) {
        var dispatch = param.dispatch, getState = param.getState;
        var queries = new Map();
        window.addEventListener("message", function() {
            var _ref = _async_to_generator(function(e) {
                var targetOrigin, _;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            targetOrigin = getState().popUpParent.targetOrigin;
                            if (e.origin !== targetOrigin || e.data.type !== actionType) {
                                return [
                                    2
                                ];
                            }
                            _ = e.data.action;
                            switch(_){
                                case "initiate":
                                    return [
                                        3,
                                        1
                                    ];
                                case "unsubscribe":
                                    return [
                                        3,
                                        3
                                    ];
                                case "reset":
                                    return [
                                        3,
                                        4
                                    ];
                            }
                            return [
                                3,
                                5
                            ];
                        case 1:
                            return [
                                4,
                                initiateInPopUp(dispatch, api, e.data, queries, actionType, e.source, targetOrigin)
                            ];
                        case 2:
                            _state.sent();
                            return [
                                3,
                                5
                            ];
                        case 3:
                            unsubscribeInPopUp(queries, e.data);
                            return [
                                3,
                                5
                            ];
                        case 4:
                            resetInPopUp(queries, e.data);
                            return [
                                3,
                                5
                            ];
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(e) {
                return _ref.apply(this, arguments);
            };
        }());
        var middlewareInstance = originalMiddleware({
            dispatch: dispatch,
            getState: getState
        });
        return function(next) {
            return function(action) {
                if (popUpCloseMatcher(action)) {
                    queries.forEach(function(query) {
                        return query.unsubscribe();
                    });
                    queries.clear();
                }
                return middlewareInstance(next)(action);
            };
        };
    };
};
var endpointPopupInitiate = function(originalInitiate, actionType, endpointName, definition) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return function(dispatch, getState) {
            if ("popUp" in getState()) {
                var _args_;
                var postMessage = function(message) {
                    var targetOrigin = getState().popUp.targetOrigin;
                    return window.opener.postMessage(message, {
                        targetOrigin: targetOrigin
                    });
                };
                var requestId = getRequestId();
                postMessage({
                    type: actionType,
                    endpointName: endpointName,
                    action: "initiate",
                    args: args,
                    requestId: requestId
                });
                var responsePromise = new Promise(function(resolve) {
                    var listener = function(e) {
                        var targetOrigin = getState().popUp.targetOrigin;
                        if (e.origin !== targetOrigin || e.data.type !== actionType || e.data.action !== "initiate/response" || e.data.requestId !== requestId) {
                            return;
                        }
                        window.removeEventListener("message", listener);
                        resolve(e.data.result);
                    };
                    window.addEventListener("message", listener);
                });
                var _args__track;
                return _object_spread_props(_object_spread({}, responsePromise), {
                    unwrap: function() {
                        return responsePromise.then(function(result) {
                            if ("data" in result) {
                                return result.data;
                            }
                            throw "error" in result ? result.error : new Error("Result doesn't contain data");
                        });
                    },
                    unsubscribe: function() {
                        return responsePromise.then(function(result) {
                            if ("requestId" in result) {
                                postMessage({
                                    type: actionType,
                                    action: "unsubscribe",
                                    requestId: result.requestId
                                });
                            }
                        });
                    },
                    reset: function() {
                        return responsePromise.then(function(result) {
                            if ("requestId" in result) {
                                postMessage({
                                    type: actionType,
                                    action: "reset",
                                    requestId: result.requestId
                                });
                            }
                        });
                    },
                    arg: {
                        endpointName: endpointName,
                        originalArgs: args[0],
                        type: definition.type,
                        track: (_args__track = (_args_ = args[1]) === null || _args_ === void 0 ? void 0 : _args_.track) !== null && _args__track !== void 0 ? _args__track : true
                    }
                });
            } else {
                return dispatch(originalInitiate.apply(void 0, _to_consumable_array(args)));
            }
        };
    };
};
var popupModule = function() {
    return {
        name: popupModuleName,
        init: function(api) {
            var actionType = "rtk-popup/".concat(api.reducerPath);
            api.middleware = rtkPopupMiddleware(api, api.middleware, actionType);
            return {
                injectEndpoint: function(endpointName, definition) {
                    var endpoint = api.endpoints[endpointName];
                    var initiate = endpoint.initiate;
                    endpoint.initiate = endpointPopupInitiate(initiate, actionType, endpointName, definition);
                }
            };
        }
    };
};

export { focusPopUp, openPopUp, popUpCloseMatcher, popUpParentReducer, popupAlreadyOpened, popupMiddleware, popupModule, popupModuleName, popupParentMiddleware, popupReducer };
